/* jshint esversion: 6 */
/* jshint esversion: 11 */
import { useContext, useEffect, useState, useCallback } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { showTost } from '../showTost';

const Razorpay = ({ Amount, ItemType, ItemId }) => {
    const { basUrl, setPayClose, setPlanId, setTransactionId, page, setBuyCoin } = useContext(MyContext);

    const [userData, setUserData] = useState();
    const [started, setStarted] = useState(false);

    const updatePaymentState = useCallback((status, transactionId) => {
        document.body.style.overflow = "auto";

        if (page === "Upgrade") {
            setPlanId(status);
            if (transactionId) setTransactionId(transactionId);
        } else if (page === "Wallet") {
            setPayClose(status);
        } else {
            setBuyCoin(status);
        }
    }, [page, setBuyCoin, setPayClose, setPlanId, setTransactionId]);

    const openPayModal = useCallback(async () => {
        if (!Amount || !userData || started) return;
        setStarted(true);

        const itemType = ItemType || (page === "Upgrade" ? "plan" : page === "Wallet" ? "wallet" : "package");
        const itemId = ItemId || 0;

        let order;
        try {
            const orderRes = await axios.post(`${basUrl}create_payment_order`, {
                uid: userData.id,
                item_type: itemType,
                item_id: itemId,
                amount: Amount,
                payment_gateway: "Razorpay",
            });

            if (orderRes.data.Result !== "true") {
                throw new Error(orderRes.data.ResponseMsg || "Unable to create payment order.");
            }

            order = orderRes.data;
            if (!order.checkout || !order.checkout.gateway_order_id || !order.checkout.key_id) {
                throw new Error("Razorpay checkout data missing from backend.");
            }
        } catch (err) {
            showTost({ title: err.message || "Unable to create Razorpay order." });
            updatePaymentState("PaymentNotDone");
            return;
        }

        const options = {
            key: order.checkout.key_id,
            amount: order.checkout.amount,
            currency: order.checkout.currency,
            order_id: order.checkout.gateway_order_id,
            name: "GoMeet",
            description: `${itemType} purchase`,
            handler: async (response) => {
                try {
                    const verifyRes = await axios.post(`${basUrl}verify_payment`, {
                        order_id: order.order_id,
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                    });

                    if (verifyRes.data.Result === "true" && verifyRes.data.status === "granted") {
                        updatePaymentState("PaymentVerified", response.razorpay_payment_id);
                    } else {
                        throw new Error(verifyRes.data.ResponseMsg || "Razorpay payment verification failed.");
                    }
                } catch (err) {
                    showTost({ title: err.message || "Razorpay payment verification failed." });
                    updatePaymentState("PaymentNotDone");
                }
            },
            modal: {
                ondismiss: () => {
                    updatePaymentState("PaymentNotDone");
                }
            },
            prefill: {
                name: userData && userData?.name,
                contact: userData && userData?.mobile,
                email: userData && userData?.email,
            },
            notes: {
                address: "some address",
            },
            theme: {
                color: "#F37254",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    }, [Amount, ItemId, ItemType, basUrl, page, started, updatePaymentState, userData]);

    useEffect(() => {
        const localData = localStorage.getItem("Register_User");
        if (!Amount || !localData) return;
        const parsedData = JSON.parse(localData);
        setUserData(parsedData);
    }, [Amount]);

    useEffect(() => {
        if (userData && Amount && !started) {
            openPayModal();
        }
    }, [Amount, userData, started, openPayModal]);

    return null;
};

export default Razorpay;
